import ApiBase from "Services/Api/ApiBase";

export default new class extends ApiBase {
    route = '/admin/surveys/:survey/responses';
};
